import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import styled from "styled-components";
import TextF3 from "./TextF3";
import TextF6 from "./TextF6";
import TextF7 from "./TextF7";
import { Container, Row, Col, SmallContainer } from "./Grid";
import { themeGet } from "styled-system";
import ExerciseDefaultIconUrl from "../images/exercise-icon.svg";
import ExerciseAnsweredIconUrl from "../images/exercise-answered.svg";
import ExerciseRejectedIconUrl from "../images/exercise-rejected.svg";

const ExerciseStatus = styled(TextF6)`
  color: ${props =>
    props.headerIcon == "answered"
      ? "#19ca94"
      : props.headerIcon == "rejected"
      ? "#FF556E"
      : "rgba(41, 38, 76, 0.5)"};
  position: relative;
  padding-left: 60px;
  padding-top: 10px;
  margin-bottom: 2.5rem;
  :before {
    content: "";
    display: block;
    background: ${props =>
      props.headerIcon == "answered"
        ? `url(${ExerciseAnsweredIconUrl})`
        : props.headerIcon == "rejected"
        ? `url(${ExerciseRejectedIconUrl})`
        : `url(${ExerciseDefaultIconUrl})`};
    width: 44px;
    height: 44px;
    position: absolute;
    left: 0;
    top: 2px;
  }
`;

const ExerciseHeading = styled(TextF3)`
  position: relative;
  margin-top: 0;
`;

const styledF7 = styled(TextF7)`
  height: ${props => (props.showText ? "auto" : "150px")};
  font-family: ${themeGet("fonts.TTNormsProRegular")};
  line-height: 1.7;
  overflow: hidden;
  ${props =>
    props.showText
      ? `@media only screen and (min-width: 900px){
    overflow: visible;
  }`
      : ""}
  padding-bottom: 4ren;
  position: relative;
  margin: 0;
  :after {
    content: "";
    display: ${props => (props.showText ? "none" : "block")};
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 150px;
    background: linear-gradient(
      to bottom,
      rgba(246, 244, 244, 0),
      rgba(246, 244, 244, 0.9),
      rgba(246, 244, 244, 1)
    );
  }
  a {
    color: #9c329c;
    text-decoration: underline;
    :hover {
      text-decoration: none;
    }
  }
  strong {
    font-family: ${themeGet("fonts.TTNormsProBold")};
    font-weight: normal;
  }
  img {
    width: 100%;
    height: auto;
    display: block;
    margin: 2rem 0;
  }
  .tablewrapper {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    margin: 2rem 0;
    max-width: 90vw;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: inline-block;

    @media screen and (max-width: 900px) {
      background-image:
        linear-gradient(to right, #f6f4f4, #f6f4f4),
        linear-gradient(to left, #f6f4f4, #f6f4f4),
        linear-gradient(to right, rgba(0, 0, 0,.25), #f6f4f4),
        linear-gradient(to left, rgba(0, 0, 0,.25), #f6f4f4);
      background-position: left center, right center, left center, right center;
      background-repeat: no-repeat;
      background-color: rgba(246, 244, 244, 0);
      background-size: 30px 100%, 30px 100%, 15px 100%, 15px 100%;
      background-attachment: local, local, scroll, scroll;
    }

    @media only screen and (min-width: 900px) {
      overflow: visible;
    }
  }
  table {
    overflow: auto;
    width: 100%;
    border: none;
    font-size: 1rem;
    font-family: ${themeGet("fonts.TTNormsProRegular")};
    font-weight: normal;
    border-collapse: collapse;
    th,
    td {
      border: none;
      text-align: left;
      padding: 1rem 1rem;
    }
    tr:nth-child(even) {
      background-color: rgba(235, 233, 239, 0);
    }
    tr:nth-child(odd) {
      background-color: rgba(235, 233, 239, 1);
    }
    tr:first-child {
      font-family: ${themeGet("fonts.TTNormsProBold")};
      font-weight: normal;
    }
    tr {
      td,
      th {
        border: 1px solid #29264c;
      }
    }
  }
`;

const QuizBodyWrapper = styledF7.withComponent("div");

const QuizHeader = props => {
  const {
    quizTitle,
    quizBody,
    submitted,
    loggedIn,
    matchingLocale,
    error,
    dynamicContent,
    rejectedAnswer
  } = props;
  return (
    <SmallContainer>
      {submitted ? (
        <ExerciseStatus headerIcon={"answered"}>
          <FormattedMessage id="quiz.status.answered" />
        </ExerciseStatus>
      ) : rejectedAnswer ? (
        <ExerciseStatus headerIcon={"rejected"}>
          <FormattedMessage id="quiz.status.rejected" />
        </ExerciseStatus>
      ) : (
        <ExerciseStatus headerIcon={"unanswered"}>
          <FormattedMessage id="quiz.status.unanswered" />
        </ExerciseStatus>
      )}
      <ExerciseHeading>{quizTitle}</ExerciseHeading>
      <QuizBodyWrapper showText={loggedIn && matchingLocale}>
        <div dangerouslySetInnerHTML={{ __html: quizBody }} />
        {dynamicContent ? dynamicContent : null}
      </QuizBodyWrapper>
    </SmallContainer>
  );
};

QuizHeader.propTypes = {
  quizTitle: PropTypes.string.isRequired,
  quizBody: PropTypes.string.isRequired,
  submitted: PropTypes.bool.isRequired
};

export default QuizHeader;
